import React from 'react';
import PropTypes from 'prop-types';
import { ArrowDropUp as ArrowDropUpIcon, ArrowDropDown as ArrowDropDownIcon } from '@material-ui/icons';

import useStyles from './Select.styles';

const Select = ({
  children,
  title,
  selectedItems,
  numberOfHiddenSelection,
  onToggle,
  isOpen,
  optionsListRef,
}) => {
  const classes = useStyles();

  return (
    <div className={classes.container} ref={optionsListRef}>
      <div className={classes.select} onClick={onToggle}>
        <p className={classes.text}>
          <strong className={classes.strong}>
            {title}
            :
          </strong>
          {' '}
          {selectedItems}
          {numberOfHiddenSelection !== 0 && (
            <strong className={classes.strong}>
              +
              {numberOfHiddenSelection}
            </strong>
          )}
        </p>
        {isOpen ? (
          <ArrowDropDownIcon className={classes.arrow} />
        ) : (
          <ArrowDropUpIcon className={classes.arrow} />
        )}
      </div>
      {isOpen && children}
    </div>
  );
};

Select.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  selectedItems: PropTypes.string.isRequired,
  numberOfHiddenSelection: PropTypes.number,
  onToggle: PropTypes.func,
  isOpen: PropTypes.bool,
  optionsListRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]).isRequired,
};

Select.defaultProps = {
  numberOfHiddenSelection: 0,
  onToggle: () => {},
  isOpen: false,
};

export default Select;
